module.exports = __webpack_public_path__ + "img/rlcj2.131c1fde.png";